export function createFormHostTokenUrl(
  redirect,
  token,
  formHost = process.env.REACT_APP_FORM_HOST_URL
) {
  if (!redirect || !token || !formHost) {
    return null;
  }

  try {
    const redirectUrl = new URL(redirect);
    const formHostUrl = new URL(formHost);
    const formHostPath = formHostUrl.pathname.replace(/\/$/, '');

    if (
      redirectUrl.origin !== formHostUrl.origin ||
      redirectUrl.pathname !== `${formHostPath}/token` ||
      redirectUrl.search ||
      redirectUrl.hash
    ) {
      return null;
    }

    redirectUrl.searchParams.set('token', token);
    return redirectUrl.toString();
  } catch {
    return null;
  }
}
